import { MerchantId, SetHeaderService } from "@/helper/authenticationHelper";
import service from "../baseHttpService";

class PaymentService {
  DoGetTransactionRemainPayment(input: any) {
    const _input = {
      merchantId: MerchantId(),
      transactionId: input.transactionId,
      transactionTypeId: input.transactionType,
    };
    return service.peakRealTimeAPI
      .post("/api/Payment/GetTransactionRemainPayment", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}
export default new PaymentService();
